import { log } from '../utils/log-utils.js';

const PAGE_MANAGER_ID = 'PageManager';
const PAGE_MODULES = import.meta.glob('../pages/*.js');

// 페이지 설정: 중앙에서 별도 설정 파일로 분리하는 것을 고려할 수 있습니다.
const PAGE_CONFIG = {
    pages: {
        'home': { path: 'home.js' },
        'convert': { path: 'convert.js' },
        'qrcode': { path: 'qrcode.js' },
        'timer': { path: 'timer.js' },
        'help': { path: 'help.js' },
        'contact': { path: 'contact.js' },
        'privacy': { path: 'privacy.js' },
        'terms': { path: 'terms.js' },
        'game': { path: 'game.js' }
    },
    // i18n 키와 페이지 ID 매핑
    i18nKeys: {
        'home': 'urls.home',
        'convert': 'urls.convert',
        'qrcode': 'urls.qrcode',
        'timer': 'urls.timer',
        'help': 'urls.help',
        'contact': 'urls.contact',
        'privacy': 'urls.privacy',
        'terms': 'urls.terms',
        'game': 'urls.game'
    }
};

class PageManager {
    constructor() {
        this.pageConfig = PAGE_CONFIG;
    }

    /**
     * 현재 URL 경로에서 페이지 ID를 추출합니다.
     * @returns {string} 현재 페이지 ID (e.g., 'home', 'convert')
     */
    getCurrentPageId() {
        const path = window.location.pathname;
        const pageName = path.substring(path.lastIndexOf('/') + 1) || 'index.html';
        const pageId = pageName.replace('.html', '');
        return (pageId === 'index' || pageId === '') ? 'home' : pageId;
    }

    /**
     * i18n URL 키를 기반으로 페이지 설정 정보를 찾습니다.
     * @param {string} i18nKey - 'urls.home'과 같은 번역 키
     * @returns {object|null} 페이지 설정 객체 또는 null
     */
    getPageMapEntryByI18nKey(i18nKey) {
        for (const [pageId, key] of Object.entries(this.pageConfig.i18nKeys)) {
            if (key === i18nKey) {
                return this.pageConfig.pages[pageId];
            }
        }
        return null;
    }

    /**
     * 페이지 ID에 해당하는 페이지 스크립트를 초기화합니다.
     * @param {string} pageId - 초기화할 페이지의 ID
     */
    async initPage(pageId) {
        const pageInfo = this.pageConfig.pages[pageId];
        if (!pageInfo || !pageInfo.path) {
            log(PAGE_MANAGER_ID, `No script path found for page ID: ${pageId}`, 'warn');
            return;
        }

        try {
            const modulePath = `../pages/${pageInfo.path}`;
            if (PAGE_MODULES[modulePath]) {
                const pageModule = await PAGE_MODULES[modulePath]();
                console.log(`[${PAGE_MANAGER_ID}] Module loaded for page '${pageId}':`, pageModule);

                if (pageModule.default && typeof pageModule.default.init === 'function') {
                    await pageModule.default.init();
                    log(PAGE_MANAGER_ID, `Page '${pageId}' initialized successfully.`);
                } else {
                    log(PAGE_MANAGER_ID, `No default export with an init function found for page '${pageId}'.`, 'warn');
                }
            } else {
                log(PAGE_MANAGER_ID, `Module not found for path: ${modulePath}`, 'error');
            }
        } catch (error) {
            console.error(`[${PAGE_MANAGER_ID}] Error initializing page '${pageId}':`, error);
        }
    }
}

export default PageManager;

